import { ElementRef, NgZone } from "@angular/core";
import { take } from "rxjs/operators";

export function scheduleMatDatepickerPopupReposition(ngZone: NgZone): void {
  ngZone.onStable.pipe(take(1)).subscribe(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (typeof window === "undefined") return;
        window.dispatchEvent(new Event("resize"));
      });
    });
  });
}

export function attachMatDatepickerContentResizeReposition(
  elementRef: ElementRef<HTMLElement>,
  ngZone: NgZone
): () => void {
  const RO = typeof globalThis !== "undefined" ? (globalThis as unknown as { ResizeObserver?: new (cb: () => void) => { disconnect(): void; observe(el: Element): void } }).ResizeObserver : undefined;
  if (!RO) {
    return () => {};
  }
  const content = elementRef.nativeElement.closest("mat-datepicker-content") as HTMLElement | null;
  if (!content) {
    return () => {};
  }
  const ro = new RO(() => {
    ngZone.run(() => {
      if (typeof window === "undefined") return;
      window.dispatchEvent(new Event("resize"));
    });
  });
  ro.observe(content);
  return () => ro.disconnect();
}
